import {SoopButtonIcon, SoopLoading} from '@soop-ui/soop-ui';
import {useExpandedFaq} from '@/hooks/help';
import {FaqBoardMobileProps} from '@/components/help/common/FaqBoard';
import FaqItem from '@/components/help/common/FaqBoard/FaqItem';
import EmptyBoard from '@/components/help/common/EmptyBoard';
import styles from '@/components/help/pc/common/FaqBoard/FaqBoard.module.scss';

const FaqBoard = ({
  type,
  data,
  isFetching,
  fetchNextPage,
  hasNextPage,
}: FaqBoardMobileProps) => {
  const {expandedId, setExpandedId} = useExpandedFaq();
  const faqList = data?.faqList || [];

  return !isFetching && faqList.length === 0 ? (
    <EmptyBoard type={type} />
  ) : (
    <div>
      <div className={styles.FaqListArea}>
        {faqList.map((item) => (
          <FaqItem
            key={item.kbId}
            item={item}
            isExpanded={expandedId === item.kbId}
            onExpand={() => setExpandedId(item.kbId)}
          />
        ))}
        {isFetching && <SoopLoading isDevice='mobile' />}
      </div>
      {!isFetching && hasNextPage && (
        <div className={styles.MoreBtnArea}>
          <SoopButtonIcon
            iconHeight='16px'
            iconWidth='16px'
            onClick={() => fetchNextPage()}
            radius='12'
            size={40}
            startIconName='icoPlus'
            variant='linePrimary'>
            더보기
          </SoopButtonIcon>
        </div>
      )}
    </div>
  );
};

export default FaqBoard;
